module.exports = __webpack_public_path__ + "static/media/First_Aid_Compliance.16a7b359.jpg";